import { getStore } from "store";
import { ConnectionStatus } from "../records/connection-request";
import redirectOnLogin from "helpers/redirectOnLogin";

export default function (nextState, replace, callback) {
    const store = getStore();
    const {
        legacyRetailers: { requestedConnections = [] },
        scope: { brand = {} },
    } = store.getState();

    // redirect to default page is current user is blocked by brand
    if (brand && requestedConnections.find((c) => c.status === ConnectionStatus.BLOCKED && c.brand_id === brand._id)) {
        redirectOnLogin({ replace, location: nextState.location });
        callback();
    } else {
        callback();
    }
}
